import { log } from "@framework/relay/logger";
import ServerMiddleware from "@framework/relay/server/network/server-middleware";

const logMiddleware: ServerMiddleware = (next) => async (ctx) => {
  const start = Date.now();

  const result = await next(ctx);

  log.info(
    {
      duration: Date.now() - start,
      url: ctx.url,
      cache: ctx.cache,
      // Use structured log context (SHA-256 hash added by APQ middleware if available)
      ...ctx.logContext,
    },
    "GraphQL response",
  );

  return result;
};

export default logMiddleware;
